<script setup lang="ts">
import type { DealCard } from '#shared/types/deal'

withDefaults(defineProps<{
  deals: readonly DealCard[]
  loading?: boolean
  eagerImages?: number
}>(), {
  eagerImages: 4,
})
</script>

<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
    <!-- Skeleton loading -->
    <template v-if="loading">
      <UCard v-for="i in 12" :key="i" class="overflow-hidden">
        <template #header>
          <USkeleton class="aspect-video w-full" />
        </template>
        <div class="p-3 space-y-2">
          <USkeleton class="h-3 w-24" />
          <USkeleton class="h-4 w-full" />
          <USkeleton class="h-4 w-3/4" />
          <USkeleton class="h-6 w-28" />
        </div>
        <template #footer>
          <USkeleton class="h-9 w-full" />
        </template>
      </UCard>
    </template>

    <!-- Deal cards -->
    <template v-else>
      <DealCard
        v-for="(deal, index) in deals"
        :key="deal.id"
        :deal="deal"
        :image-priority="index < eagerImages"
      />
    </template>
  </div>

  <!-- Empty state -->
  <div v-if="!loading && deals.length === 0" class="text-center py-16 text-gray-500 dark:text-gray-400">
    <UIcon name="i-heroicons-face-frown" class="w-12 h-12 mx-auto mb-3 opacity-50" />
    <p class="text-lg font-medium">Nenhuma oferta encontrada</p>
    <p class="text-sm mt-1">Tente mudar os filtros ou volte mais tarde.</p>
  </div>
</template>
